import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import Heading from '~/app/components/atoms/Heading'
import Icon from '~/app/components/atoms/Icons'
import Paragraph from '../atoms/Paragraph'

/**
 *
 * @returns: En employee card, der viser information om en medarbejder.
 * @example: <EmployeeCard />
 * @alias: EmployeeCard
 * @module: components/atoms/EmployeeCard
 * @summary: Denne komponent bruges til at vise information om en medarbejder.
 * @see: src/components/atoms/EmployeeCard.tsx
 * @version: 1.0.0
 * @property: [employee]
 * @author: Kasper Buchholtz
 *
 **/

// split every 2 digits with a space
const splitEveryTwoDigits = (str) => {
  return str.replace(/(\d{2})(?=\d)/g, '$1 ')
}

const EmployeeCard = ({ employee }) => {
  return (
    <div className="col-span-2 sm:col-span-4 xl:col-span-6 group">
      <EmployeeCard.Portrait employee={employee} />
      <EmployeeCard.Info employee={employee} />
    </div>
  )
}
export default EmployeeCard

EmployeeCard.Portrait = Portrait
EmployeeCard.Info = Info

function Portrait({ employee }) {
  return (
    <div className="relative object-cover w-full overflow-hidden rounded-md aspect-1">
      {employee.image && (
        <Image
          src={employee.image}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          loading="lazy"
          width={employee.imageWidth || 800}
          height={employee.imageHeight || 600}
          alt={employee.title || 'Billede af' + employee.title}
          className="object-cover w-full h-full"
        />
      )}
    </div>
  )
}
function Info({ employee }) {
  return (
    <div className="mt-6">
      <Heading spacing="none" type="h5" tag="h5">
        {employee.title}
      </Heading>
      <Paragraph className='font-medium text-DabraRød/60'>
      {employee.positionTitle}
      <br />
      {employee.positionTag}
      </Paragraph>
      <div className="mt-2 space-y-3 ">
        <Paragraph>
         <Link
          className="flex gap-3 text-regular hover:text-rød transition-colors"
          href={`tel:${employee.phone}`}
        >
          Tlf: {employee.phone}
        </Link>
        <Link
          className="flex gap-3 text-regular hover:text-rød transition-colors"
          href={`mailto:${employee.email}`}
        >
          {employee.email}
        </Link>
        </Paragraph>
      </div>
    </div>
  )
}
